<template>
    <div id="app">
	    <template v-if="!hasPerformedInitialLoad || isWaitingForWhoami">
		    <Loader/>
	    </template>
	    <template v-else>
		    <PopupPrompt  v-if="popupPrompt.prompt !== '' && typeof popupPrompt.callback === 'function'" />
		    <Guide v-if="whichGuide !== ''" :guide="whichGuide" :class="whichGuide" />
		    <Notification />
		    <router-view/>
		    <template v-if="isAuthorized">
                <Sound/>
			    <Chat />
			    <Profile/>
		    </template>
            <KoebTshirtPopup v-if="showTshirtPopup" @closePopup="$store.commit('ux/setShowTshirtPopup', false)" />
	    </template>
    </div>
</template>

<script>
    import Chat from "@/components/Chat";
    import Guide from "@/components/Guide";
    import Profile from "@/components/Profile";
    import Sound from "@/components/Sound"
    import Notification from "@/components/Notification";
    import performInitialStateLoad from "@/mixins/performInitialStateLoad";
    import {mapState} from "vuex";
    import PopupPrompt from "@/components/popup/PopupPrompt";
    import Loader from "@/components/Loader";

    // Tshirt Popup
    import KoebTshirtPopup from "@/components/popup/KoebTshirtPopup";

	export default {
		name: 'Home',
		mixins: [performInitialStateLoad],
        components: {
	        Loader,
	        PopupPrompt,
	        Profile,
	        Sound,
            Chat,
	        Guide,
	        Notification,
	        KoebTshirtPopup
        },
		computed: {
			...mapState('vorbasse', {
				hasPerformedInitialLoad: 'hasPerformedInitialLoad',
				isAuthorized: 'isAuthorized',
				isWaitingForWhoami: 'isWaitingForWhoami',
				popupPrompt: 'popupPrompt'
			}),
			...mapState('ux', {
				showTshirtPopup: state => state.showTshirtPopup
			}),
            whichGuide(){
				let john = ['boderne', 'kraemmer', 'produkt']
				if(john.indexOf(this.$route.name) !== -1){
					return 'john'
                }
				if(this.$route.name === 'token'){
					return ''
                }
				return 'gert'
            }
		}
	}
</script>
<style lang="scss">
    @import "@/assets/scss/_main";
    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }

    #nav {
        display: none;
        padding: 30px 0px;
        position: fixed;
        z-index: 5;
        margin-top: 80px;
        a {
            font-weight: bold;
            color: #2c3e50;

            &.router-link-exact-active {
                color: #42b983;
            }
        }
    }
</style>
